var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"out-of-stock"},[_c('span',{attrs:{"data-test":'outOfStockSpan'+_vm.position,"id":'outOfStockSpan-id'+_vm.position}},[_vm._v("\n    Out Of Stock\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }